import { Box } from "@chakra-ui/react";
import moment from "moment-timezone";
import { SlotStyle } from "../../types";

interface BackgroundGridProps {
  hours: number[];
  slotHeight: number;
  show15Minutes: boolean;
  columnIndex: number;
  getSlotStyle?: (time: Date, columnIndex: number) => SlotStyle | undefined;
  date: Date;
  timezone?: string;
}

export default function BackgroundGrid({
  hours,
  slotHeight,
  show15Minutes,
  columnIndex,
  getSlotStyle,
  date,
  timezone,
}: BackgroundGridProps) {
  return (
    <>
      {hours.map((hour) => (
        <Box key={hour}>
          <Box
            position="absolute"
            top={`${hour * slotHeight}px`}
            width="100%"
            height="1px"
            borderBottomWidth="1px"
            borderBottomColor="gray.200"
            pointerEvents="none"
          />

          {show15Minutes &&
            [15, 30, 45].map((minutes) => (
              <Box
                key={`${hour}-${minutes}`}
                position="absolute"
                top={`${hour * slotHeight + (minutes / 60) * slotHeight}px`}
                width="100%"
                height="1px"
                borderBottomWidth="1px"
                borderBottomColor="gray.100"
                pointerEvents="none"
              />
            ))}

          {getSlotStyle &&
            [0, 15, 30, 45].map((minutes) => {
              const cellTime = timezone
                ? moment.tz(date, timezone).clone().set({ hour, minute: minutes, second: 0, millisecond: 0 }).toDate()
                : (() => { const t = new Date(date); t.setHours(hour, minutes, 0, 0); return t; })();
              const style = getSlotStyle(cellTime, columnIndex);
              if (!style) return null;
              return (
                <Box
                  key={`slot-${hour}-${minutes}`}
                  position="absolute"
                  top={`${hour * slotHeight + (minutes / 60) * slotHeight}px`}
                  width="100%"
                  height={`${slotHeight / 4}px`}
                  bg={style.bg}
                  opacity={style.opacity}
                  pointerEvents="none"
                />
              );
            })}
        </Box>
      ))}
    </>
  );
}
